import(/* webpackMode: "eager" */ "/vercel/path0/app/(site)/[lng]/template.tsx");
